// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Home-module_wrap__3gi7K","paper":"Home-module_paper__24JJ2"};